import { useCallback, useState } from 'react';

import {
  CreateCaseState,
  ICreateSupportCaseInput,
  IUseCreateSupportCase,
  SupportCaseProvider,
} from '../types';

export const useCreateSupportCase = ({
  createCase,
  handleError,
}: SupportCaseProvider): IUseCreateSupportCase => {
  const [caseReferenceNumber, setCaseReferenceNumber] = useState<string | null | undefined>(null);
  const [createCaseState, setCreateCaseState] = useState<CreateCaseState>(CreateCaseState.DEFAULT);
  const [createCaseError, setCreateCaseError] = useState('');

  const createSupportCase = useCallback(
    async (caseInfo: ICreateSupportCaseInput) => {
      setCreateCaseState(CreateCaseState.LOADING);
      try {
        const caseId = await createCase(caseInfo);
        setCaseReferenceNumber(caseId);
        setCreateCaseState(CreateCaseState.SUCCESS);
        return caseId;
      } catch (error) {
        const message = handleError(error);
        if (message) {
          setCreateCaseError(message);
        }
        setCreateCaseState(CreateCaseState.ERROR);
        return null;
      }
    },
    [createCase, handleError]
  );

  return { caseReferenceNumber, createCaseState, createSupportCase, createCaseError };
};
